module.exports = __webpack_public_path__ + "img/52002744_L.2110c9e0.png";